<template>
	<div :class="['custom-dropdown', 'element', {'light-mode' : $route.meta.headerColor === 'light'}]" v-if="loaded">
		<div class="selected element" @click="toggleDropdown">
			<img class="flag element" :src="require(`@/drc/assets/images/flags/${selectedLanguage.short}.svg`)" :alt="selectedLanguage.name">
			<span class="language-name element">{{ selectedLanguage.name }}</span>
		</div>
		<ul v-if="dropdownOpen" class="dropdown-list element">
			<li class="element" v-for="(language, index) in languages" :key="index" @click="selectLanguage(language)">
				<img class="flag element" :src="require(`@/drc/assets/images/flags/${language.short}.svg`)" :alt="language.name">
				<span class="selected-name element">{{ language.name }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
import {LANGUAGE, LANGUAGE_ARRAY, PAGE_NAME} from "@/common/utils/constants";
import {EventBusNavbar, EventProjectLanguage} from "@/common/configurations/event-bus";

export default {
	name: "ApplicationLanguageDropdown",
	data() {
		return {
			languages: LANGUAGE_ARRAY,
			dropdownOpen: false,
			loaded: false,
			selectedLanguage: null
		}
	},
	created() {
		document.addEventListener("click", this.closeDropdownOnOutsideClick);
		EventBusNavbar.$on('language-change-from-form', () => {
			this.selectedLanguage = LANGUAGE[this.$i18n.locale.toLowerCase()];
		});
	},
	destroyed() {
		document.removeEventListener("click", this.closeDropdownOnOutsideClick);
		EventBusNavbar.$off("language-change-from-form");
	},
	mounted() {
		let lang = localStorage.getItem("language");
		if (!lang) {
			lang = LANGUAGE.en.short.toLowerCase();
		}
		this.selectedLanguage = LANGUAGE[lang];
		this.selectLanguage(this.selectedLanguage);
		this.loaded = true;
	},
	methods: {
		closeDropdownOnOutsideClick(event) {
			if (this.dropdownOpen && !event.target.classList.contains('element')) {
				this.toggleDropdown();
			}
		},
		toggleDropdown() {
			this.dropdownOpen = !this.dropdownOpen;
		},
		selectLanguage(language) {
			this.selectedLanguage = language;
			this.$i18n.locale = language.short;
			localStorage.setItem("language", language.short.toLowerCase());
			let allowedForViewPaths = [PAGE_NAME.singleCS, PAGE_NAME.singleCSWithDates];
			if (allowedForViewPaths.includes(this.$route.name)) {
				EventProjectLanguage.$emit("project-change-language", this.selectedLanguage.short);
			} else {
				EventBusNavbar.$emit("language-change", this.selectedLanguage.short);
			}
			this.dropdownOpen = false;
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.custom-dropdown {
	position: relative;
	display: inline-block;
	cursor: pointer;
	top: 0;
	transition: top 0.4s ease-in;

	@media (max-width: $mobile) {
		margin-right: 50px;
	}

	.selected {
		display: flex;
		align-items: center;
		gap: 8px;
		border-radius: 4px;
		width: 105px;
		padding: 12px 16px;
		background: $newsletter-hover-background;

		@media (max-width: $mobile) {
			width: 48px;
			height: 100%;

			.language-name {
				display: none;
			}
		}
	}

	.dropdown-list {
		position: absolute;
		top: 100%;
		left: 0;
		background: white;
		border: 1px solid #E5E5EA;
		width: 100%;
		list-style: none;
		padding: 0;
		margin: 0;
		border-radius: 8px;
		overflow: hidden;

		@media (max-width: $mobile) {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		li {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 6px;
			cursor: pointer;

			span {
				color: $newsletter-hover-background;
			}

			@media (max-width: $mobile) {
				justify-content: center;
				padding-top: 15px;
				padding-bottom: 15px;
				min-height: 25px;

				.selected-name {
					display: none;
				}
			}

			.flag {
				width: 20px;
				height: 15px;
			}

			&:hover {
				background: #FFF1D2;
			}
		}
	}

	&.light-mode {
		.selected {
			background: #ffffff;

			.language-name {
				color: #001F33;
			}
		}

		.dropdown-list {
			box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.1);
		}
	}
}
</style>
